import gql from 'graphql-tag';

export default gql`
  query getStadiumConfig {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          allegiantStadiumProductIds
          allegiantStadiumBookingCacheCounter
        }
      }
    }
  }
`;
